import React, { Component } from 'react';
import CriterioDeBusqueda from './CriterioDeBusqueda';
import ValorDeBusqueda from './ValorDeBusqueda';
import TipoDeBusqueda from './TipoDeBusqueda';

class Filtros extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { data, actions, registrosActivos, arrayFiltrosDefinitivoLength } = this.props;

        let mostrarFiltros = data.mostrarFiltros;
        let classModoDesplegableLink = mostrarFiltros ? "clickable none-text-decoration ti-angle-up orange" : "clickable none-text-decoration ti-angle-down orange";

        return (
            <div>
                <div className="VistaInstanciaParametro-Filtros-Background VistaInstanciaParametro-Filtros-Marign-Top VistaInstanciaParametro-Filtros-Marign-Bottom">
                    <span className='VistaInstanciaParametro-Filtros-Valor-Busqueda-Marign-Right'>Filtros</span>
                    <a className={classModoDesplegableLink} onClick={() => actions.mostrarFiltros(!data.mostrarFiltros)}></a>
                </div>

                {mostrarFiltros ?
                    <div>
                        <CriterioDeBusqueda data={data} actions={actions} registrosActivos={registrosActivos} />

                        <div className="VistaInstanciaParametro-Filtros-Linea"></div>

                        <ValorDeBusqueda data={data} actions={actions}/>

                        <div className="VistaInstanciaParametro-Filtros-Linea"></div>

                        <TipoDeBusqueda data={data} actions={actions} registrosActivos={registrosActivos} arrayFiltrosDefinitivoLength={arrayFiltrosDefinitivoLength} />
                    </div>
                    : null
                }
            </div>
        )
    }
}

export default Filtros